import React, { Component } from 'react';
import { Alert, InputGroup, InputGroupAddon, InputGroupText, UncontrolledTooltip, FormFeedback, Spinner, Form, FormGroup, Label, Row, Col, Input, Button, Card, CardHeader, CardBody, CardTitle, CardText, FormText } from 'reactstrap';
import { withRouter } from 'react-router';
import _ from 'underscore';
import { Global } from '~/App'
import API from '~/API';
import ModalImagen from '~/components/ModalImagen'
import ModalPorQue from '~/components/ModalPorQue'
import Turnstile from '~/components/Turnstile';

class IngresaLectura extends Component {
    constructor(props) {
        super(props);
        const allowedEmpresas = Global.empresas.filter(e => 
            props.Usuario || !Global.isAnonBlocked(e.key)
        );
        const defaultEmpresa = allowedEmpresas.some(e => e.key === Global.empresaDefecto) 
            ? Global.empresaDefecto 
            : (allowedEmpresas[0]?.key || "");

        this.state = {
            mensajes: [],
            cargando: false,
            lectura: "",
            servicio: (props.IngresarLectura || {}).servicio || "",
            fecha: "",
            documento: "",
            email: "",
            empresa: defaultEmpresa
        }
        this.captchaRef = React.createRef();
        this.pendingData = null;
        this.onCaptchaResolved = this.onCaptchaResolved.bind(this);
        this.onCaptchaError = this.onCaptchaError.bind(this);
    }
    onCaptchaError() {
        this.pendingData = null;
        this.setState({ cargando: false });
    }
    componentWillMount() {
        if (!this.props.Usuario && Global.isAnonBlocked()) {
            this.props.history.replace("/sucursal");
            return;
        }

        if (this.props.IngresarLectura) {
            this.setState({ servicio: this.props.IngresarLectura.servicio.toString(), empresa: this.props.IngresarLectura.empresa.toString() });
        }
        if (this.props.Usuario) {
            this.setState({ email: this.props.Usuario.email });
        }
    }

    // ... (sin cambios en los métodos de la clase como componentWillReceiveProps, submit, etc.)
    cambiarNumeroDocumento = event => {
        const { value, maxLength } = event.target;
        const message = value.slice(0, maxLength);
        this.setState({
            documento: message
        });
    }
    handleChangeInput = event => {
        const { value, maxLength } = event.target;
        const message = value.slice(0, maxLength);
        this.setState({
            lectura: message
        });
    };
    onCaptchaResolved(token) {
        if (!token || !this.pendingData) return;
        this.enviarLectura(token);
    }
    async enviarLectura(captchaToken) {
        var data = this.pendingData;
        this.pendingData = null;
        var mensajes = [];
        try {
            var response = await API.Call(`Consulta/${this.state.empresa}/Ingresar/Lectura` + (this.props.Usuario && this.props.IngresarLectura ? "" : "/Anonima"), { ...data, captcha: captchaToken });
            if (this.captchaRef.current) this.captchaRef.current.reset();
            mensajes.push({ tipo: "success", texto: response });
            this.setState({ cargando: false, mensajes });
            if (this.props.FuncionOk) {
                this.props.FuncionOk();
                this.props.FuncionCerrar();
            }
        }
        catch (error) {
            if (this.captchaRef.current) this.captchaRef.current.reset();
            mensajes.push({ tipo: "danger", texto: error });
            this.setState({ cargando: false, mensajes });
        }
    }
    async submit(e) {
        e.preventDefault();
        var idServicio = this.state.servicio;
        var lectura = this.state.lectura;
        var fecha = this.state.fecha;
        var documento = this.state.documento;
        //estos los deberia ver en la api.
        var usuario = this.props.Usuario || {};
        var nombre = usuario.nombre || "";
        var apellido = usuario.apellido || "";
        var nombreCompleto = nombre != "" ? `${nombre} ${apellido}` : "";
        var rut = usuario.rut || "";
        var email = this.props.Usuario ? this.props.Usuario.email : this.state.email;
        var phoneNumber = usuario.phoneNumber || "";
        var data = {
            IdServicio: idServicio,
            Fecha: fecha,
            Nombre: nombreCompleto,
            Rut: rut,
            Lectura: lectura,
            Email: email,
            Telefono: phoneNumber,
            Documento: documento,
            Empresa: this.state.empresa
        };
        var mensajes = [];
        var valido = true;
        if (email === "") {
            mensajes.push({ tipo: "warning", texto: "Debes ingresar email" });
            valido = false;
        }
        if (lectura === "") {
            mensajes.push({ tipo: "warning", texto: "Debes ingresar lectura" });
            valido = false;
        }
        if (!this.props.IngresarLectura && idServicio === "") {
            mensajes.push({ tipo: "warning", texto: "Debes indicar número de cuenta" });
            valido = false;
        }
        if (!Global.csd && !this.props.IngresarLectura && documento === "") {
            mensajes.push({ tipo: "warning", texto: "Debes ingresar número de documento" });
            valido = false;
        }
        if (idServicio > 2147483647) {
            mensajes.push({ tipo: "warning", texto: "Número se servicio muy grande, debe ser menor a 2147483647" });
            valido = false;
        }
        if (!valido) {
            this.setState({ cargando: false, mensajes });
            return;
        }

        this.setState({ cargando: true, mensajes: [] });
        this.pendingData = data;

        const necesitaCaptcha = !(this.props.Usuario && this.props.IngresarLectura) && Global.csd;
        if (necesitaCaptcha) {
            if (this.captchaRef.current) {
                this.captchaRef.current.execute();
            }
        } else {
            this.enviarLectura(null);
        }
    }

    render() {
        const allowedEmpresas = Global.empresas.filter(e => 
            this.props.Usuario || !Global.isAnonBlocked(e.key)
        );

        return (<div>
            <Card className="panel-ingreso-lectura">
                <CardHeader className="titulo-modal">{`Ingreso de Lectura${this.props.Usuario && this.props.IngresarLectura ? ` en cuenta ${Global.AgregaDV(this.props.IngresarLectura.servicio)}` : ""}`}</CardHeader>
                <CardBody className="cuerpo-modal">
                    {/* El Row es necesario para que el offset de Col funcione correctamente */}
                    <Row>
                        {/* Se utiliza el sistema de rejilla para centrar el contenido.
                        - En pantallas pequeñas (sm) ocupa todo el ancho.
                        - En medianas (md) y grandes (lg) se centra con un offset. */}
                        <Col sm="12" md={{ size: 8, offset: 2 }} lg={{ size: 6, offset: 3 }} className="bordeCompleto">
                            <Form onSubmit={this.submit.bind(this)} noValidate>
                                <div className="intro-text">
                                    <CardTitle tag="h5">Informe la lectura de su medidor</CardTitle>
                                    <CardText>
                                        {
                                            (Global.empresas.find(e => e.key === this.state.empresa)?.otros?.PermiteLecturaFueraPeriodo)
                                            ? "Si nos informa su lectura durante el período de facturación, esta será usada para calcular su boleta. Fuera de este período, nos ayudará a mejorar la estimación de sus próximos consumos."
                                            : "Si nos informa su lectura durante el período de facturación, esta será usada para calcular su boleta. No se permite el ingreso de lecturas fuera de este período."
                                        }
                                    </CardText>
                                </div>

                                {this.props.Usuario && this.props.IngresarLectura ?
                                        (
                                            <FormGroup>
                                                <Label for="lectura" className="font-weight-bold">Lectura de su medidor</Label>
                                                <InputGroup>
                                                    <InputGroupAddon addonType="prepend"><InputGroupText>💡</InputGroupText></InputGroupAddon>
                                                    <Input onChange={this.handleChangeInput} value={this.state.lectura} type="number" name="lectura" id="lectura" maxLength="9" placeholder="Ingrese solo los dígitos en negro" bsSize="lg" />
                                                </InputGroup>
                                                <FormText color="muted">Ingrese todos los dígitos del visor, sin considerar decimales.</FormText>
                                            </FormGroup>
                                        ) : (
                                            <>
                                                <div className="form-step">
                                                    <h6 className="form-step-title">Paso 1: Identifique su cuenta</h6>
                                                    {allowedEmpresas.length > 1 &&
                                                        <FormGroup>
                                                            <Label for="empresa">Empresa</Label>
                                                            <Input id="empresa" type="select" value={this.state.empresa} onChange={e => this.setState({ empresa: e.target.value })}>
                                                                {allowedEmpresas.map(e => <option value={e.key} key={e.key}>{e.nombre}</option>)}
                                                            </Input>
                                                        </FormGroup>
                                                    }
                                                    <FormGroup>
                                                        <Label for="servicio" className="numero-cuenta"><span>Número de Cuenta</span><ModalPorQue /></Label>
                                                        <InputGroup>
                                                            <InputGroupAddon addonType="prepend"><InputGroupText>👤</InputGroupText></InputGroupAddon>
                                                            <Input value={this.state.servicio} onChange={e => this.setState({ servicio: e.target.value })} type="number" name="servicio" id="Servicio" placeholder="Ej: 1234567" className="text-right" />
                                                            <InputGroupAddon id="asyntecPortalDVServicio" addonType="append">
                                                                <Button color="link" disabled>{this.state.servicio ? <div> - {Global.DV(this.state.servicio)}</div> : <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>}</Button>
                                                                <UncontrolledTooltip placement="top" target="asyntecPortalDVServicio">Dígito Verificador</UncontrolledTooltip>
                                                            </InputGroupAddon>
                                                        </InputGroup>
                                                    </FormGroup>
                                                    {!Global.csd &&
                                                        <FormGroup>
                                                            <Label for="documento"><span>Últimos 4 dígitos de su carnet</span><ModalImagen empresa={this.state.empresa} /></Label>
                                                            <InputGroup>
                                                                <InputGroupAddon addonType="prepend"><InputGroupText>📄</InputGroupText></InputGroupAddon>
                                                                <Input value={this.state.documento} onChange={this.cambiarNumeroDocumento.bind(this)} type="number" name="documento" id="Documento" placeholder="Requerido para validar" maxLength="15" />
                                                            </InputGroup>
                                                        </FormGroup>
                                                    }
                                                </div>
                                                <div className="form-step">
                                                    <h6 className="form-step-title">Paso 2: Informe su lectura</h6>
                                                    <FormGroup>
                                                        <Label for="lectura"><span>Lectura del Medidor</span><ModalImagen empresa={this.state.empresa} TipoImagen="imagenMedidor" /></Label>
                                                        <InputGroup>
                                                            <InputGroupAddon addonType="prepend"><InputGroupText>💡</InputGroupText></InputGroupAddon>
                                                            <Input onChange={this.handleChangeInput} value={this.state.lectura} type="number" name="lectura" id="lectura" maxLength="9" placeholder="Ingrese solo los dígitos en negro" />
                                                        </InputGroup>
                                                        <FormText color="muted">No considere los decimales (generalmente en rojo).</FormText>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label for="Email">Correo electrónico de contacto</Label>
                                                        <InputGroup>
                                                            <InputGroupAddon addonType="prepend"><InputGroupText>📧</InputGroupText></InputGroupAddon>
                                                            <Input value={this.state.email} invalid={this.state.email !== "" && !Global.ValidateEmail(this.state.email)} onChange={e => this.setState({ email: e.target.value })} type="email" name="email" id="Email" placeholder="sunombre@ejemplo.com" />
                                                            <FormFeedback>Debe ser un correo válido para que podamos contactarle.</FormFeedback>
                                                        </InputGroup>
                                                    </FormGroup>
                                                </div>
                                                {Global.csd && (
                                                    <Turnstile
                                                        ref={this.captchaRef}
                                                        size="invisible"
                                                        sitekey={Global.apiKeyCaptcha}
                                                        onChange={this.onCaptchaResolved}
                                                        onErrored={this.onCaptchaError}
                                                        onExpired={this.onCaptchaError}
                                                    />
                                                )}
                                            </>
                                        )
                                }

                                {this.state.mensajes.length > 0 &&
                                    <div className="mt-4">
                                        {_.map(this.state.mensajes, (m, i) => <Alert key={i} color={m.tipo} className="text-center">{m.texto}</Alert>)}
                                    </div>
                                }
                                <Row className="mt-4">
                                    <Col xs="12" sm={this.props.FuncionCerrar ? 6 : 12}>
                                        <Button block size="lg" type="submit" disabled={!this.state.lectura || !this.state.servicio || (!this.props.Usuario && !Global.ValidateEmail(this.state.email)) || this.state.cargando} color="primary">
                                            {this.state.cargando ? 'Enviando...' : 'Enviar Lectura'}
                                        </Button>
                                    </Col>
                                    {this.props.FuncionCerrar &&
                                        <Col xs="12" sm={6} className="mt-2 mt-sm-0">
                                            <Button block size="lg" color="secondary" onClick={() => { this.props.FuncionCerrar() }}>Cancelar</Button>
                                        </Col>
                                    }
                                </Row>
                            </Form>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>)
    }
}

export default withRouter(IngresaLectura);